export const guards = {
  needsRSA: context => !context.inputs.isSmartMode && !context.outputs.rsa,
  needsTextAds: context => context.inputs.isSmartMode && !context.outputs.textAds,
  needsImageAds: context => context.inputs.isSmartMode && !context.outputs.imageAds,
  needsImages: context => !context.inputs.isSmartMode && context.inputs.isPMaxLite && !context.outputs.images,
  needsTargets: context => !context.outputs.targets,
  needsKeywords: context => !context.outputs.keywords,
};
